import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';

import { history } from './history';

import App from './frame/App';

import './index.less';

ReactDOM.render(
  <Router history={history} >
    <App />
  </Router>,
  document.getElementById('app')
);


// WEBPACK FOOTER //
// ./src/index.jsx